// Beta Call To Action Component
// ==============================
// Feature #287: Refined with new design system
// Replaces TestimonialsSection during beta/test period

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../ui/Button';
import DesignLine from '../ui/DesignLine';

const BetaCallToAction: React.FC = () => {
  const { t } = useTranslation('landing');

  return (
    <section id="beta" className="py-20 md:py-28 bg-canvas dark:bg-background-dark">
      <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
        {/* Feature #287: Refined badge with frame styling */}
        <div className="inline-flex items-center px-4 py-2 bg-design-line-orange/10 dark:bg-design-line-orange/20 text-design-line-orange border border-design-line-orange/20 rounded-full text-sm font-medium mb-6">
          {t('beta.badge')}
        </div>

        {/* Feature #280: Serif display font for headings */}
        <h2 className="text-3xl sm:text-4xl font-display font-bold text-neutral-dark dark:text-white mb-4">
          {t('beta.title')}
        </h2>

        {/* Feature #287: Design-line accent */}
        <div className="flex justify-center mb-6">
          <DesignLine variant="horizontal" width="80px" height={2} />
        </div>

        <p className="text-lg text-neutral-medium dark:text-gray-400 max-w-2xl mx-auto mb-4 font-sans">
          {t('beta.subtitle')}
        </p>

        <p className="text-sm font-medium text-primary-600 dark:text-primary-400 mb-8 font-sans">
          {t('beta.studentLine')}
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link to="/register">
            <Button size="lg">{t('beta.createAccount')}</Button>
          </Link>
          <a href="mailto:feedback@lyra-study.com">
            <Button variant="outline" size="lg">{t('beta.sendFeedback')}</Button>
          </a>
        </div>

        <p className="text-sm text-gray-500 dark:text-gray-400 mt-6 font-sans">
          {t('beta.freeNote')}
        </p>
      </div>
    </section>
  );
};

export default BetaCallToAction;
